import React, { useState, useEffect } from "react";
import infocardimg from '../img/oylesine.png'
import kalemlipng from '../img/kalemlipng.png'
import './../styles/Kvk.scss'
import Api from "../common/api";

const Kvk = () => {

  const [datas, setData] = useState([])
  const lang = localStorage.getItem("lang");
  React.useEffect(() => {
    Api.get("/Documents/list/2").then((res) => {
      setData(res.data.items);
    });
  }, []);

  return (
    datas
      ? datas.map((data) => (
        lang == "en"? (
        <div className="kvk-info-container">
          <div className="kvk-info-card">
            <div className="info-card-img">
              <img src={data.File_En.split(".")[1] == "docx" ? kalemlipng : infocardimg} alt="asdas" style={{ width: '66', height: '86' }} />
            </div>
            <div className="kvk-info">
              <h4>{data.Name_EN}</h4>
              <a href={'https://sankoenerji.com.tr' + data.File_En} target="_blank" className="document-download-btn" > Click to review </a >
            </div>
          </div>
        </div>
        ):( <div className="kvk-info-container">
        <div className="kvk-info-card">
          <div className="info-card-img">
            <img src={data.Image.split(".")[1] == "docx" ? kalemlipng : infocardimg} alt="asdas" style={{ width: '66', height: '86' }} />
          </div>
          <div className="kvk-info">
            <h4>{data.Name_TR}</h4>
            <a href={'https://sankoenerji.com.tr' + data.Image} target="_blank" className="document-download-btn" > İncelemek için tıklayınız </a >
          </div>
        </div>
      </div>)
      )) : null
  )
}

export default Kvk
